export interface Company {
  id: number;
  title: string;
  priceGroup: number;
  canUsePointSystem: boolean;
  createdAt: Date;
  updatedAt: Date;
}

export const getEmptyCompany = (): Company => ({
  id: 0,
  title: '',
  priceGroup: 1,
  canUsePointSystem: false,
  createdAt: new Date(),
  updatedAt: new Date(),
});

export const companyFromResponse = (responseData: any): Company => ({
  id: responseData.id,
  title: responseData.title,
  priceGroup: responseData.price_group,
  canUsePointSystem: responseData.can_use_point_system,
  createdAt: new Date(responseData.created_at),
  updatedAt: new Date(responseData.updated_at),
});

export const companyToUpsertRequest = (company: Company) => ({
  title: company.title,
  price_group: company.priceGroup,
  can_use_point_system: company.canUsePointSystem,
});
